module.exports = __webpack_public_path__ + "static/media/cauliflower.3b2f2a5b.png";